import styled from '@emotion/styled'

import { Button } from '@/components/Button'
import { decodeURL } from '@/core/utils/dom/decodeURL'
import type { BlockButtonProps } from '@/models'

import PartnerItem, { type PartnerItemProps } from './PartnerItem'

export interface ListPartnerProps extends BlockButtonProps {
  items: PartnerItemProps[]
}

const ListPartnerStyles = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  height: 'auto',
  marginBottom: 'var(--space-2)',
})

const ListPartnerButton = styled(Button)`
  width: 100%;
  max-width: 20.5rem;
`

const ListPartner = ({
  items,
  hasButton,
  button,
  buttonLabel,
  buttonType,
  buttonValue,
  buttonModifier,
  buttonRounded,
  buttonAriaLabel,
}: ListPartnerProps) => {
  const buttonProps = {
    label: buttonLabel || button?.label,
    type: buttonType || button?.action?.type,
    value: buttonValue || button?.action?.value,
    modifier: buttonModifier || 'outline',
    rounded: buttonRounded || false,
    ariaLabel: buttonAriaLabel,
  }

  return (
    <>
      <ListPartnerStyles>
        {items.map((partner, index) => (
          <PartnerItem key={`lpartner_item_${index}`} {...partner} />
        ))}
      </ListPartnerStyles>

      {hasButton && buttonProps && (
        <div className="et-ta-center">
          <ListPartnerButton
            size="lg"
            action={buttonProps.type}
            rounded={buttonProps.rounded}
            modifier={buttonProps.modifier}
            value={decodeURL(buttonProps.value)}
            aria-label={buttonProps.ariaLabel}
          >
            {buttonProps.label}
          </ListPartnerButton>
        </div>
      )}
    </>
  )
}

export default ListPartner
